module.exports = __webpack_public_path__ + "img/brigitte.698f9854.jpg";